mutation CopyCampaign(
    $campaignId: ID!
    $name: String!
    $masterTemplateIds: [ID!]!
    $languages: [String!]!
    $sectionId: ID
    $opendcPlatformSettings: SCALAR_MIXED
    $copyOptions: InputCopyCampaignOptions
    $jobId: ID
) {
    copyCampaign(
        campaignId: $campaignId
        name: $name
        masterTemplateIds: $masterTemplateIds
        languages: $languages
        sectionId: $sectionId
        opendcPlatformSettings: $opendcPlatformSettings
        copyOptions: $copyOptions
        jobId: $jobId
    ) {
        jobId
        campaign {
            _id
        }
    }
}
